import React, { useState } from 'react';
import PropTypes from 'prop-types';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    Grid,
    IconButton,
    TextField,
    Chip
} from '@material-ui/core';
import { Cancel } from '@material-ui/icons';
import CloseIcon from '@material-ui/icons/Close';
import { withStyles } from '@material-ui/core/styles';
import Button from '../../components/Button';
import ProviderSearchBar from '../../components/ProviderSearchBar';

function CreateProviderRestrictedModal(props) {
    const {
        viewOnly,
        open,
        save,
        onClose,
        classes: { modal, modalContent, selectInput },
    } = props;

    const [toProvider, setToProvider] = useState({});
    const [toPatientId, setToPatientId] = useState('');
    const [validationErrors, setValidationErrors] = useState({});
    const [providerName, setProviderName] = useState(null)


    const validate = () => {
        let valid = true;
        const nextState = {};

        if (!toProvider.id) {
            nextState.toProvider = 'Required';
            valid = false;
        }

        setValidationErrors(nextState);
        return valid;
    };

    const onSave = async () => {
        save({
            id: toProvider.id,
        })
    }


    const removeProvider = (provider) => {
        delete provider.fullTitle
        setProviderName(null)
    }

    const renderToProvider = () =>
        viewOnly ? (
            <TextField
                inputProps={{
                    disabled: true,
                }}
                label="Provider"
                variant="filled"
                name="providerName"
                fullWidth
                value={toProvider.label}
                className={selectInput}
            />
        ) : (
                <ProviderSearchBar
                    label="Provider"
                    name="toProvider"
                    placeholder="Search for a provider..."
                    errorMessage={validationErrors.toProvider}
                    onSelect={provider => {
                        if (provider) {
                            setValidationErrors({ ...validationErrors, toProvider: false });
                        }
                        setToProvider(provider || {});
                        setProviderName(provider && provider.fullTitle)
                    }}
                    className={selectInput}
                />
            );

    return (
        <>
            <Dialog
                fullWidth
                open={open}
                onClose={onClose}
                classes={{ paper: modal }}
                maxWidth={'xl'}
            >
                <DialogTitle>
                    <Grid container alignItems="center">
                        <Grid item xs={11}>
                            <h2>Select Restricted Provider</h2>
                        </Grid>

                        <Grid item xs={1}>
                            <IconButton aria-label="Close" onClick={onClose}>
                                <CloseIcon />
                            </IconButton>
                        </Grid>
                    </Grid>
                </DialogTitle>
                <DialogContent classes={{ root: modalContent }}>
                    {renderToProvider()}
                    <div>
                        {providerName !== null && providerName ?
                            <div>
                                <Chip
                                    key={toProvider.id}
                                    onDelete={() => removeProvider(toProvider)}
                                    clickable
                                    deleteIcon={(<Cancel />)}
                                    label={providerName}
                                />
                            </div> : null
                        }
                    </div>
                    <Grid item xs={12} lg={12}>
                        <Button className="custom-update-btn customSubmitBtn"
                            disabled={providerName === null ? true : false}
                            fullWidth
                            color="primary"
                            variant="contained"
                            onClick={onSave}
                            onClickValidation={toProvider.id && toPatientId.length >= 1 ? '' : validate}
                        >
                            Save
              </Button>
                    </Grid>
                </DialogContent>
            </Dialog>
        </>
    );
}

CreateProviderRestrictedModal.propTypes = {
    viewOnly: PropTypes.bool,
    note: PropTypes.object,
    patient: PropTypes.object,
    open: PropTypes.bool.isRequired,
    save: PropTypes.func,
    onClose: PropTypes.func.isRequired,
};

const styles = () => ({
    modal: {
        maxHeight: '700px',
        height: '310px'
    },
    modalContent: {
        overflow: 'visible',
    },
    actions: {
        marginTop: '1em',
    },
    input: {
        margin: '0.5em 0',
    },
    selectInput: {
        marginTop: '0.5em',
        marginBottom: '1em',
    },
    previewImg: {
        maxWidth: 300,
        maxHeight: 300,
    }
});

export default withStyles(styles)(CreateProviderRestrictedModal);
